export default function (to, from, savedPosition) {
  if (savedPosition) {
    return savedPosition
  } else {
    const position = {}

    return new Promise(resolve => {
      if (to.matched.some(route => route.meta.scrollTop)) {
        position.x = 0
        position.y = 0
      }

      resolve(position)
    })
  }
}
